import { storyblokInit, apiPlugin } from "@storyblok/react";
import HomeContainer from "@components/core/Storyblok/Home/HomeContainer";
import MediumBanner from "@components/core/Storyblok/Home/MediumBanner";
import LargeBannerImage from "@components/core/Storyblok/Home/LargeBannerImage";
import LargeBannerV2 from "@components/core/Storyblok/Home/LargeBannerV2";
import CollectionList from "@components/core/Storyblok/Home/CollectionList";
import CollectionList6 from "@components/core/Storyblok/Home/CollectionList6";
import ProductSliderV2 from "@components/core/Storyblok/Home/ProductSliderV2";
import NavSearchContainer from "@components/core/Storyblok/NavSearch/NavSearchContainer";
import NavsearchLink from "@components/core/Storyblok/NavSearch/NavsearchLink";
import NavsearchGroupLinks from "@components/core/Storyblok/NavSearch/NavsearchGroupLinks";
import NavsearchBanner from "@components/core/Storyblok/NavSearch/NavsearchBanner";
import PromoBannerContainer from "@components/core/Storyblok/PromoBanner/PromoBannerContainer";
import PromoBanner from "@components/core/Storyblok/PromoBanner/PromoBanner";
import ClosetPromoBannerContainer from "@components/core/Storyblok/ClosetPromoBanner/ClosetPromoBannerContainer";
import ClosetPromoBanner from "@components/core/Storyblok/ClosetPromoBanner/ClosetPromoBanner";

const previewMode =
  typeof window !== "undefined" ? window.location !== window.parent.location : false;

const customInitStoryblok = () =>
  storyblokInit({
    accessToken: process.env.NEXT_PUBLIC_STORYBLOK_KEY,
    use: [apiPlugin],
    bridge: previewMode,
    components: {
      HomeContainer,
      LargeBannerImage,
      LargeBannerV2,
      CollectionList,
      CollectionList6,
      MediumBanner,
      ProductSliderV2,
      NavSearchContainer,
      NavsearchLink,
      NavsearchGroupLinks,
      NavsearchBanner,
      PromoBannerContainer,
      PromoBanner,
      ClosetPromoBannerContainer,
      ClosetPromoBanner,
    },
  });

export default customInitStoryblok;
